import { Link } from 'react-router-dom';
import Arrow from '../../components/ui/Arrow';
import { brand } from '../../content/site';
import { localizedPath, useLocale, useMessages } from '../../i18n/locale';

export default function ModulePage({ module }) {
  const locale = useLocale();
  const copy = useMessages().modulePage;
  return (
    <main className="module-page">
      <section className="module-hero">
        <div className="module-hero__grid" aria-hidden="true" />
        <div className="container module-hero__inner">
          <div className="module-hero__copy">
            <div className="module-breadcrumb">
              <Link to={localizedPath(locale)}>{copy.home}</Link>
              <span>/</span>
              <span>{module.name}</span>
            </div>
            <div className="module-eyebrow">
              <span className="module-eyebrow__dot" />
              {module.number} / {module.eyebrow}
            </div>
            <h1>
              {module.title.split('\n').map((line, index) => (
                <span key={line} className={index ? 'module-hero__muted' : undefined}>
                  {line}
                </span>
              ))}
            </h1>
            <p>{module.description}</p>
            <div className="module-hero__actions">
              <Link className="button button--primary" to={localizedPath(locale)}>
                {copy.backHome} <Arrow up />
              </Link>
              <span className="module-draft-label">
                {copy.moduleLabel} / {module.number}　·　{copy.comingSoon}
              </span>
            </div>
          </div>
          <div className="module-art" aria-hidden="true">
            <div className="module-art__ring module-art__ring--outer" />
            <div className="module-art__ring module-art__ring--inner" />
            <div className="module-art__core">
              <span>{module.number}</span>
              <small>{module.eyebrow}</small>
            </div>
            <span className="module-art__point module-art__point--one" />
            <span className="module-art__point module-art__point--two" />
            <span className="module-art__plus">+</span>
          </div>
        </div>
        <div className="container module-hero__bottom">
          <span>{brand.tagline.toUpperCase()}</span>
          <span>{module.number} / 06</span>
        </div>
      </section>
      <section className="module-slots">
        <div className="container">
          <div className="module-slots__intro">
            <div>
              <span className="module-small-label">
                {copy.exploreLabel} / {module.name}
              </span>
              <h2>{module.sectionTitle}</h2>
            </div>
            <p>{copy.intro}</p>
          </div>
          <div className="module-slot-grid">
            {module.slots.map((slot) => (
              <article className="module-slot" key={slot.number}>
                <div className="module-slot__top">
                  <span>{slot.number} / 03</span>
                  <span className="module-slot__icon" aria-hidden="true">
                    ↗
                  </span>
                </div>
                <div>
                  <span className="module-slot__caption">{slot.caption}</span>
                  <h3>{slot.title}</h3>
                  <p>{slot.detail}</p>
                </div>
                {slot.href ? (
                  <Link to={localizedPath(locale, slot.href)} className="module-slot__link">
                    {copy.explorePage} <Arrow up />
                  </Link>
                ) : (
                  <span className="module-slot__pending">
                    {copy.pending} <span aria-hidden="true">○</span>
                  </span>
                )}
              </article>
            ))}
          </div>
        </div>
      </section>
      <section className="module-end">
        <div className="container module-end__inner">
          <span className="module-small-label">{copy.nextLabel}</span>
          <p>
            {copy.moreOnWay}
            <span>.</span>
          </p>
          <Link to={localizedPath(locale, '/company/contact')}>
            {copy.getInTouch} <Arrow up />
          </Link>
        </div>
      </section>
    </main>
  );
}
